import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { utils, writeFile } from "xlsx";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import ProductServices from "../../../services/ProductServices";
import Loader from "../Loader/loader";

const IndigoStock = () => {
    const [open2, setOpen2] = useState(true);
    const [reportData, setReportData] = useState([]);
    const [stores, setStores] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [Totalcount, setTotalcount] = useState(0);

    // ✅ Pagination states
    const [page, setPage] = useState(1);
    const [limit] = useState(500);
    const [totalPages, setTotalPages] = useState(1);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await ProductServices.getIndigoReportAll({
                page,
                limit,
                search: searchTerm,
            });

            // ✅ Correct extraction
            const rows = response?.data || [];
            const totalPagesFromApi = response?.totalPages || 1;

            const cleanData = rows.map((item) => ({
                ...item,
                partNo: item.partNo || "",
            }));

            setReportData(cleanData);
            setTotalPages(totalPagesFromApi);
            setTotalcount(response?.totalCount)

            // ✅ Extract unique stores dynamically
            const uniqueStores = [];
            cleanData.forEach((item) => {
                item.stores.forEach((store) => {
                    if (!uniqueStores.find((s) => s.storeId === store.storeId)) {
                        uniqueStores.push(store);
                    }
                });
            });
            setStores(uniqueStores);
        } catch (err) {
            console.error("Fetch error:", err.response?.data || err.message);
            Swal.fire("Error", "Failed to load data", "error");
        } finally {
            setLoading(false);
        }
    };



    // ✅ Fetch whenever page or searchTerm changes
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searchTerm]);



    function handleAmount(qty, rate) {
        return (qty * rate)
    }
    const formatIndianNumber = (num) => {
        if (!num && num !== 0) return "-";
        const x = num.toString().split(".");
        let lastThree = x[0].slice(-3);
        const otherNumbers = x[0].slice(0, -3);
        if (otherNumbers !== "") {
            lastThree = "," + lastThree;
        }
        const formatted =
            otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
        return x[1] ? formatted + "." + x[1] : formatted;
    };

    // Export to Excel (uses current filteredData from backend)
    const exportToXLS = async () => {
        try {
            Swal.fire({
                title: "Please wait",
                text: "Exporting full report...",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            let allData = [];
            let currentPage = 1;

            // 🌀 Fetch all pages sequentially
            while (true) {
                const response = await ProductServices.getIndigoReportAll({
                    page: currentPage,
                    limit: 500,
                    search: searchTerm,
                });

                const rows = response?.data || [];
                allData = [...allData, ...rows];

                if (currentPage >= response?.totalPages) break;
                currentPage++;
            }

            Swal.close();

            // 🧹 Prepare Excel rows
            const cleanData = allData.map((item, index) => {
                const current = item.totalCurrentStock ?? 0;
                const transition = item.totalTransitionQty ?? 0;
                const total = current + transition;

                const row = {
                    "S.No": index + 1,
                    "Part No": item.partNo,
                    Description: item.description,
                    Category: item.category?.name || "-",
                    "Sub Category": item.subCategory?.name || "-", // ✅ Added field
                    Unit: item.unit?.name || "-",
                    "Total Current": current,
                    "Total Transition": transition,
                    "Total (All)": total,
                    Rate: item?.rate || 0,
                    Amount: (total * (item?.rate || 0)).toFixed(2),
                };

                // 🏪 Add store-wise breakdown dynamically
                item.stores.forEach((store) => {
                    row[`${store.storeName} - Current`] = store.currentStock;
                    row[`${store.storeName} - Transition`] = store.transitionQty;
                    row[`${store.storeName} - Total`] =
                        store.currentStock + store.transitionQty;
                });

                return row;
            });

            // 📘 Generate Excel file
            const worksheet = utils.json_to_sheet(cleanData);
            const workbook = utils.book_new();
            utils.book_append_sheet(workbook, worksheet, "IndigoStock Report");
            writeFile(workbook, "IndigoStock_Report_All.xlsx");

            Swal.fire("Success", "Full report downloaded!", "success");
        } catch (error) {
            Swal.fire("Error", "Failed to export report", "error");
            console.error(error);
        }
    };



    if (loading) {
        return (
            <Loader />
        )
    }
    return (
        <div className="col-xl-12">
            {/* 🔍 Search */}
            <div className="filter cm-content-box box-primary">
                <div className="content-title">
                    <div className="cpa">
                        <i className="fas fa-filter me-2"></i>Filter
                    </div>
                    <div className="tools">
                        <Link
                            to={"#"}
                            className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                            onClick={() => setOpen2(!open2)}
                        >
                            <i className="fas fa-angle-up"></i>
                        </Link>
                    </div>
                </div>
                <Collapse in={open2}>
                    <div className="cm-content-body form excerpt">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-3 col-xxl-12">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by Part No, Description"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setPage(1); // reset page on new search
                                            setSearchTerm(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>

            {/* 📊 Report */}
            <div className="filter cm-content-box box-primary">
                <div className="content-title">
                    <div className="cpa">
                        <i className="fa fa-list me-2" aria-hidden="true"></i>IndigoStock Report
                        <span className="badge bg-orange ms-2">{Totalcount}</span>
                    </div>

                </div>
                <Collapse in={open2}>

                    <div className="cm-content-body form excerpt">
                        <div className="text-end me-3">
                            {!loading && reportData?.length > 0 ? (
                                <p
                                    onClick={exportToXLS}
                                    className="text-end btn btn-rounded btn-sm btn-primary me-3"
                                >
                                    <i class="fas fa-download"></i><span className="ms-2">Download Report</span>

                                </p>
                            ) : null}
                        </div>
                        <div className="card-body">
                            <div
                                className="scrolltable"
                            >

                                <table className="table table-bordered table-striped">
                                    <thead className="sticky-table-header">
                                        <tr>
                                            <th rowSpan="2">S.No</th>
                                            <th rowSpan="2">Part No</th>
                                            <th rowSpan="2">Description</th>
                                            <th rowSpan="2">Category</th>
                                            <th rowSpan="2">Sub Category</th>
                                            <th rowSpan="2">Unit</th>
                                            <th rowSpan="2">Total (All Stores)</th>
                                            <th rowSpan="2" style={{ backgroundColor: "rgb(224,254,250)" }}>Rate</th>
                                            <th rowSpan="2" style={{ backgroundColor: "rgb(127,177,212)" }}>Amount</th>
                                            {stores.map((store, index) => {
                                                const bgColor = index % 2 === 0 ? "#f0f0f0" : "#d9edf7"; // Even/Odd colors
                                                return (
                                                    <th
                                                        key={store.storeId}
                                                        colSpan="3"
                                                        className="text-center"
                                                        style={{ backgroundColor: bgColor }}
                                                    >
                                                        {store.storeName}
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            {stores.map((store, index) => {
                                                const bgColor = index % 2 === 0 ? "#f0f0f0" : "#d9edf7"; // match parent color
                                                return (
                                                    <React.Fragment key={store.storeId}>
                                                        <th style={{ backgroundColor: bgColor }}>Current</th>
                                                        <th style={{ backgroundColor: bgColor }}>Transition</th>
                                                        <th style={{ backgroundColor: bgColor }}>Total</th>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tr>
                                    </thead>


                                    <tbody>
                                        {reportData.map((item, index) => {
                                            const current = item.totalCurrentStock ?? 0;
                                            const transition = item.totalTransitionQty ?? 0;
                                            const total = current + transition;

                                            return (
                                                <tr key={item._id}>
                                                    <td>{(page - 1) * limit + index + 1}</td>
                                                    <td>{item.partNo}</td>
                                                    <td className="scrollable-description">{item.description}</td>
                                                    <td>{item?.category?.name || "-"}</td>
                                                    <td>{item?.subCategory?.name}</td>
                                                    <td>{item.unit?.name || "-"}</td>
                                                    <td>{total}</td>
                                                    <td style={{ backgroundColor: "rgb(224,254,250)" }}>{formatIndianNumber(item?.rate || 0)}</td>
                                                    <td style={{ backgroundColor: "rgb(127,177,212)" }}>{formatIndianNumber(handleAmount(total, item?.rate))}</td>
                                                    {stores.map((store, sIndex) => {
                                                        const storeData = item.stores.find((s) => s.storeId === store.storeId) || {};
                                                        const sCurrent = storeData.currentStock ?? 0;
                                                        const sTransition = storeData.transitionQty ?? 0;
                                                        const sTotal = sCurrent + sTransition;

                                                        // alternating background for each store
                                                        const bgColor = sIndex % 2 === 0 ? "#f0f0f0" : "#d9edf7";

                                                        return (
                                                            <React.Fragment key={store.storeId}>
                                                                <td style={{ backgroundColor: bgColor }}>{sCurrent}</td>
                                                                <td style={{ backgroundColor: bgColor }}>{sTransition}</td>
                                                                <td style={{ backgroundColor: bgColor }}>{sTotal}</td>
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                    </tbody>

                                </table>

                            </div>

                            {/* 📌 Pagination controls */}
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <button
                                    className="btn btn-secondary btn-sm"
                                    disabled={page === 1}
                                    onClick={() => setPage(page - 1)}
                                >
                                    Prev
                                </button>
                                <span>
                                    Page {page} of {totalPages}
                                </span>
                                <button
                                    className="btn btn-secondary btn-sm"
                                    disabled={page === totalPages}
                                    onClick={() => setPage(page + 1)}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
        </div>
    );
};

export default IndigoStock;
